
import React from 'react';
import { QrCode, Smartphone } from 'lucide-react';
import { Button } from "./ui/button";

interface DesktopBlockingScreenProps {
  appUrl: string;
}

const DesktopBlockingScreen: React.FC<DesktopBlockingScreenProps> = ({ appUrl }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neobank-primary to-neobank-secondary p-8 flex flex-col items-center justify-center text-white">
      <div className="max-w-md w-full bg-white rounded-xl shadow-2xl p-8 text-center text-neobank-dark">
        <div className="flex justify-center mb-6">
          <div className="bg-neobank-lightAccent p-4 rounded-full">
            <Smartphone className="w-12 h-12 text-neobank-primary" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold mb-3">Mobile Only App</h1>
        <p className="text-gray-600 mb-8">
          CoinPrime is designed exclusively for mobile devices. Please scan the QR code below to open the app on your phone.
        </p>
        
        <div className="bg-gray-100 p-6 rounded-lg mb-6 flex flex-col items-center">
          <QrCode className="w-16 h-16 text-neobank-primary mb-4" />
          <div className="bg-white p-4 rounded-lg border-2 border-gray-200 w-48 h-48 flex items-center justify-center">
            <img 
              src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(appUrl)}`}
              alt="QR Code to access the mobile app"
              className="w-full h-full"
            />
          </div>
        </div>
        
        <div className="text-sm text-gray-500">
          <p>Or visit directly on your mobile device:</p>
          <Button 
            variant="link" 
            className="text-neobank-primary font-medium"
            onClick={() => window.open(appUrl, '_blank')}
          >
            {appUrl}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DesktopBlockingScreen;
